import React from 'react';
import { testimonials } from '../data/angielski';
export function Testimonials() {
  // Hidden until authentic ANGIELSKI GOTOWY reviews are added in data/angielski.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-278" data-mp="3fym8yp543a6g">
      <div className="mx-auto max-w-6xl" data-id="element-279" data-mp="3azt57ofmmxjh">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-280" data-mp="3ayqat6j3icyt">
          Co mówią <em className="text-red-700" data-id="element-281" data-mp="3205zwrjs17l5">nauczyciele</em>
        </h2>
        <p className="mt-4 text-sm text-slate-900/60" data-id="element-282" data-mp="321zauj1fadyy">
          Przykładowe opinie — fikcyjne, do makiety
        </p>

        <div className="mt-12 grid gap-x-10 gap-y-14 border-t border-slate-900/15 pt-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-283" data-mp="2s1qact0ee6dr">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-284" data-mp="v859fwccnb29">
              <div className="text-sm text-amber-500" aria-label="5 na 5 gwiazdek" data-id="element-285" data-mp="q9u0dntvp4l3">
                <span aria-hidden="true" data-id="element-286" data-mp="h67ya15u5i8s">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-xl leading-snug text-slate-900" data-id="element-287" data-mp="h818trjkkmm2">
                „{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-288" data-mp="78tv338xapyf">
                <span className="font-semibold text-slate-900" data-id="element-289" data-mp="7a4z946a5zq2">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-290" data-mp="c73q9dundqk1"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}